import { publishGa4Events } from '@porterin/component-library/src/ts-utils/analytics/react-ga/EventTracker';
import { useCitySelectedContext } from '@porterin/feature/src/contexts/city-context/CityContext';
import { CityService } from '@porterin/feature/src/shared/cities/domain/entities/CitiesEntity';
import { GA_ESTIMATE_CATEGORY_CARD_ACTION } from '@porterin/feature/src/shared/core/constants/GAEventsConstants';
import {
  MIN_WIDTH_DESKTOP,
  useMediaQuery,
} from '@porterin/feature/src/shared/core/hooks/useMediaQuery';
import { CommonImage } from '@porterin/feature/src/shared/types/CommonVM';
import { serviceShortName } from '@porterin/feature/src/ui/components/CategoryCardCmp';
import NextImageV2 from '@porterin/feature/src/ui/components/NextImageV2';
import { useRouter } from 'next/router';
import React from 'react';

import styles from '../styles/CategorySelector.module.scss';

interface CategorySelectCmpProps {
  category_details: CityService;
  onCategorySelect: (service_type: string) => void;
  arrow_icon: CommonImage;
}

function CategorySelectCmp({
  category_details,
  onCategorySelect,
  arrow_icon,
}: Readonly<CategorySelectCmpProps>): React.ReactElement {
  const citySelectedContext = useCitySelectedContext();
  const isDesktop = useMediaQuery(MIN_WIDTH_DESKTOP);
  const router = useRouter();

  const selectionHandler = (): void => {
    publishGa4Events(
      citySelectedContext.category,
      GA_ESTIMATE_CATEGORY_CARD_ACTION + category_details.service_type,
      category_details.service_type,
    );
    publishGa4Events(
      citySelectedContext.category,
      `fe_homegetest_${serviceShortName(category_details.text)}_tap`,
      category_details.text,
    );

    if (isDesktop) {
      onCategorySelect(category_details.service_type);
    } else {
      router.push(category_details.link + citySelectedContext.query_params);
    }
  };

  return (
    <button
      type="button"
      className={styles['category-select-container']}
      onClick={selectionHandler}
    >
      <div className={styles['category-image-text']}>
        <div className={styles['category-image']}>
          <NextImageV2
            src={category_details.image.path}
            height={80}
            width={80}
            alt={category_details.image.alt_text}
            quality={100}
          />
        </div>
        <div className={styles['category-text']}>{category_details.text}</div>
      </div>
      <div className={styles['arrow-icon']}>
        <NextImageV2
          src={arrow_icon.path}
          height={40}
          width={40}
          alt={arrow_icon.alt_text}
          quality={100}
        />
      </div>
    </button>
  );
}

export default CategorySelectCmp;
